import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import '../../styles/TermsAndConditions.css'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'
import ReactMarkdown from 'react-markdown'
import { ENGLISH_TERMS_AND_CONDITIONS, GERMAN_TERMS_AND_CONDITIONS } from '../../assets/legal/termsAndConditionsConstants'
import { ReactComponent as ExitCross } from '../../assets/svg/ExitCross.svg'

function TermsAndConditionsContentModal({ modalIsOpen, closeModal }) {
    const { t } = useTranslation()

    useEffect(() => {
        if (modalIsOpen) {
            Modal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
            document.getElementById('my-header').style.marginTop = '-60px'
        } else {
            document.getElementById('home').style.filter = 'unset'
            document.getElementById('my-header').style.marginTop = 'unset'
        }
    }, [modalIsOpen])

    const _closeModal = () => {
        closeModal()
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            contentLabel="Tutorial Modal"
            onRequestClose={_closeModal}
            style={{
                overlay: {
                    zIndex: 1111,
                },
                content: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    padding: 0,
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'hidden',
                    position: 'absolute',
                },
            }}
        >
            <div className="terms-and-conditions-modal" style={{ zIndex: 1111, width: '80%', height: '100%', position: 'relative' }}>
                <button className="tutorial-exit-button" onClick={_closeModal}>
                    <ExitCross />
                </button>
                <div className="tutorial-right-side">
                    <p className="tutorial-modal-title">{t('Terms and Conditions')} </p>
                    <div style={{ flex: 1, overflow: 'auto' }} className="terms-and-conditions-text">
                        <ReactMarkdown>{i18n.language === 'de' ? GERMAN_TERMS_AND_CONDITIONS : ENGLISH_TERMS_AND_CONDITIONS}</ReactMarkdown>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default TermsAndConditionsContentModal
